"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  display: inline-block;\n  text-align: center;\n  \n  &::after,\n  &::before {\n    ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    height: ", ";\n    margin-left: -", ";\n    margin-right: -", ";\n  }\n"], ["\n  ", ";\n  display: inline-block;\n  text-align: center;\n  \n  &::after,\n  &::before {\n    ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    height: ", ";\n    margin-left: -", ";\n    margin-right: -", ";\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  border-top: ", " solid ", ";\n"], ["\n  ", ";\n  border-top: ", " solid ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  border-bottom: ", " solid ", ";\n"], ["\n  ", ";\n  border-bottom: ", " solid ", ";\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _defaults = require("../defaults");

var defs = _interopRequireWildcard(_defaults);

var _propTypes = require("../propTypes");

var _mixins = require("./mixins");

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Outer = _styledComponents2.default.div(_templateObject);

var Inner = _styledComponents2.default.div(_templateObject2, c.rotate(defs.hourglassAnimationSpeed), c.pseudoBlock(), c.DARK_GRAY, c.px(Math.floor(defs.hourglassCapHeight / 2)), c.px(defs.hourglassCapHeight), c.px(defs.hourglassCapHeight), c.px(defs.hourglassCapHeight));

var Top = _styledComponents2.default.div(_templateObject3, _mixins.styleGlass, defs.hourglassHeight, defs.hourglassDefaultColor);

var Bottom = _styledComponents2.default.div(_templateObject4, _mixins.styleGlass, defs.hourglassHeight, defs.hourglassActiveColor);

var Hourglass = function Hourglass() {
  return _react2.default.createElement(Outer, null, _react2.default.createElement(Inner, null, _react2.default.createElement(Top, null), _react2.default.createElement(Bottom, null)));
};

Hourglass.defaultProps = _extends({}, _propTypes.animationCommonDefaultProps, _propTypes2.hourglassDefaultProps);
Hourglass.propTypes = _extends({}, _propTypes.animationCommonPropTypes, _propTypes2.hourglassPropTypes);
exports.default = Hourglass;